import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    items: []
};

export default {mutations, actions, state}
